// App.jsx — authenticated shell + role-gated routes.
//   /login          public
//   /               Explore (A/B calculator)        — any role (tenant scoped)
//   /report         live report                     — any role (tenant scoped)
//   /pipeline       ingest/runs diagnostics         — admin only
//   /users          user management (registration)  — admin only

import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider.jsx";
import RequireAuth, { RequireRole } from "./auth/RequireAuth.jsx";
import { RunProvider, RunBanner } from "./hooks/useRun.jsx";
import Topbar from "./components/Topbar.jsx";
import Login from "./pages/Login.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import Report from "./pages/Report.jsx";
import Pipeline from "./pages/Pipeline.jsx";
import Users from "./pages/Users.jsx";

function Shell() {
  return (
    <RunProvider>
      <div className="app">
        <Topbar />
        <RunBanner />
        <main className="main">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/report" element={<Report />} />
            <Route path="/pipeline" element={<RequireRole roles={["admin"]}><Pipeline /></RequireRole>} />
            <Route path="/users" element={<RequireRole roles={["admin"]}><Users /></RequireRole>} />
          </Routes>
        </main>
      </div>
    </RunProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={<RequireAuth><Shell /></RequireAuth>} />
      </Routes>
    </AuthProvider>
  );
}
